import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M21.66 17.67a1.08 1.08 0 0 1-.04 1.6A12 12 0 0 1 4.73 2.38a1.1 1.1 0 0 1 1.61-.04z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M19.65 15.66A8 8 0 0 1 8.35 4.34", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "m14 10-5.5 5.5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 17.85V10H6.15", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Citrus";
const Citrus = memo(themed(Icon));
export {
  Citrus
};
//# sourceMappingURL=citrus.js.map
